import React, { useState, useEffect, useContext } from "react";
import CourcesStyle from "./CourcesStyle.module.css";
//import axios
import axios from "axios";
//import from react router
import { Link,useNavigate } from "react-router-dom";
//import material  ui
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";

import Typography from "@mui/material/Typography";
//import component
import { Button, ButtonError } from "../UI/Button";
import { isInCart } from "../../helper/functions";
//import context
import { CartContext } from "../../context/CartContextProvider";
import {AuthContext} from '../../context/AuthContextProvider'
//start code

const Cources = () => {
  const navigate =useNavigate()
  //context
  const { state, dispatch } = useContext(CartContext);
  const authContext=useContext(AuthContext)
  //states
  const [Cources, setCources] = useState([]);
  //use effect
  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(
        "https://academy-nyctophile.herokuapp.com/api/term/getall"
      );
      setCources(response.data.result);
    };
    getData();
  }, []);

  return (
    <div className={CourcesStyle.grid}>
      {Cources.map((cources) => (
        <div className={CourcesStyle.card}>
          <Card sx={{ maxWidth: 345 }}>
            <CardMedia
              component="img"
              alt="green iguana"
              height="140"
              image={
                require(`../../../src/assets/products/${cources.course.image}`)
                  .default
              }
            />
            <CardContent>
              <h2 style={{ fontSize: "18px", textAlign: "right" }}>
                {cources.title}
              </h2>
              <h3
                style={{
                  textAlign: "right",
                  color: "orange",
                  fontSize: "16px",
                }}
              >
                ظرفیت:
                <span
                  style={{
                    color: "#475960",
                    marginRight: "3px",
                    textDecoration: "underline",
                  }}
                >
                  {cources.capacity}
                </span>
              </h3>

              <Typography variant="body2" color="text.secondary"></Typography>
            </CardContent>

            {authContext.isAuth ? <div className={CourcesStyle.detail}>
              {isInCart(state, cources._id) ? (
                <ButtonError
                onClick={() =>
                  dispatch({ type: "REMOVE_ITEM", payload: cources })}
                >
               
                  حذف از سبد
                </ButtonError>
              ) : (
                <Button
                onClick={() =>
                  dispatch({ type: "ADD_ITEM", payload: cources })}
                >
                  افزودن به سبد
                </Button>
              )}
              <Link to={`/cources/${cources._id}`}>بیشتر...</Link>
            </div> : <div className={CourcesStyle.detail}>
              
             
             
                <Button
                onClick={() =>navigate('./Login')
                 }
                >
                  ثبت نام
                </Button>
              
              <Link to={`/cources/${cources._id}`}>بیشتر...</Link>
            </div>}
          </Card>
        </div>
      ))}
    </div>
  );
};

export default Cources;
